import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';
import { TranslateService } from '@ngx-translate/core';
import { angularMath } from 'angular-ts-math';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.css']
})
export class LandingComponent implements OnInit {
  language: string;
  // Array of available translated languages. Default=en
  availableLang = ["en", "ca", "ca-ES", "es", "es-ES"];
  days_of_life: any;
  // @ts-ignore
  translate: "";
  typed: any;

  // Tracking user’s activities
  // We can also track user’s interactions with our app. People go in your website to do a certain activity. Either it’s to read the information in your page, watch a video, play a game, or simply send you an email using your contact form. Whatever it is, you can track it and collect the data as an event
  sendEvent = () => {
    (<any>window).ga('send', 'event', {
      eventCategory: 'social-en',
      eventLabel: 'couchsurfing',
      eventAction: 'redirect',
      eventValue: 1
    });
  }

  getAge() {
    var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
    var birthday = new Date(1989, 7, 13).getTime(); //poso dia 13 enlloc 12agot1989 perquè compti el 12 ja passat
    var today = Date.now();
    this.days_of_life = angularMath.integerOfNumber(angularMath.absoluteOfNumber((today - birthday) / (oneDay)));
  }


  constructor(translate: TranslateService) {
    // @ts-ignore
    this.translate = translate;
    // @ts-ignore
    this.language = navigator.language || navigator.userLanguage;
    if (this.language == "ca-ES") {
      this.language = "ca";
    }
    if (this.language == "es-ES") {
      this.language = "es";
    }
    //  alert("navigator language = " + this.language);
    if (this.availableLang.indexOf(this.language) > -1) {
      //  alert("using navigator language i18n file");
      translate.use(this.language);

    } else {
      //  alert("using default 'en' language");
    }
    this.textslider();
  }

  textslider() {
    setTimeout(function() {
      /*--/ Start Typed /--*/
      if (this.typed) {
        console.log("moooooooort");
        this.typed.destroy();
      }
      // @ts-ignore
      if ($('.text-slider').length == 1) {
        // @ts-ignore
        var typed_strings = $('.text-slider-items').text();
        // @ts-ignore
        this.typed = new Typed('.text-slider', {
          strings: typed_strings.split(','),
          typeSpeed: 80,
          loop: true,
          backDelay: 1300,
          backSpeed: 30,
          showCursor: true
        });
      }
    }, 100);
  }


  changeLang(chosenLanguage) {
    //console.log("User ask to change to: " + chosenLanguage);
    // @ts-ignore
    this.translate.use(chosenLanguage);
    // @ts-ignore
    $(".lang").show();
    // @ts-ignore
    $("." + chosenLanguage).hide();
    this.textslider();
  }

  ngOnInit() {
    this.getAge();
    //hides current language button
    // @ts-ignore
    $("." + this.language).hide();
  }


  //jQuery contact form
  contactForm() {
    jQuery(document).ready(function($) {
      "use strict";

      //Contact
      $('form.contactForm').submit(function() {
        var f = $(this).find('.form-group'),
          ferror = false,
          emailExp = /^[^\s()<>@,;:\/]+@\w[\w\.-]+\.[a-z]{2,}$/i;

        f.children('input').each(function() { // run all inputs

          var i = $(this); // current input
          var rule = i.attr('data-rule');

          if (rule !== undefined) {
            var ierror = false; // error flag for current input
            var pos = rule.indexOf(':', 0);
            if (pos >= 0) {
              var exp = rule.substr(pos + 1, rule.length);
              rule = rule.substr(0, pos);
            } else {
              rule = rule.substr(pos + 1, rule.length);
            }

            switch (rule) {
              case 'required':
                if (i.val() === '') {
                  ferror = ierror = true;
                }
                break;

              case 'minlen':
                // @ts-ignore
                if (i.val().length < parseInt(exp)) {
                  ferror = ierror = true;
                }
                break;

              case 'email':
                // @ts-ignore
                if (!emailExp.test(i.val())) {
                  ferror = ierror = true;
                }
                break;

              case 'checked':
                if (!i.is(':checked')) {
                  ferror = ierror = true;
                }
                break;

              case 'regexp':
                // @ts-ignore
                exp = new RegExp(exp);
                // @ts-ignore
                if (!exp.test(i.val())) {
                  ferror = ierror = true;
                }
                break;
            }
            // @ts-ignore
            i.next('.validation').html((ierror ? (i.attr('title') !== undefined ? i.attr('title') : 'wrong Input') : '')).show('blind');
          }
        });
        f.children('textarea').each(function() { // run all inputs

          var i = $(this); // current input
          var rule = i.attr('data-rule');

          if (rule !== undefined) {
            var ierror = false; // error flag for current input
            var pos = rule.indexOf(':', 0);
            if (pos >= 0) {
              var exp = rule.substr(pos + 1, rule.length);
              rule = rule.substr(0, pos);
            } else {
              rule = rule.substr(pos + 1, rule.length);
            }

            switch (rule) {
              case 'required':
                if (i.val() === '') {
                  ferror = ierror = true;
                }
                break;

              case 'minlen':
                // @ts-ignore
                if (i.val().length < parseInt(exp)) {
                  ferror = ierror = true;
                }
                break;
            }
            // @ts-ignore
            i.next('.validation').html((ierror ? (i.attr('title') != undefined ? i.attr('title') : 'wrong Input') : '')).show('blind');
          }
        });
        if (ferror) return false;
        else {

          //EmailJS
          var template_params = {
            "form_email": $("#email").val(),
            "form_subject": $("#subject").val(),
            "form_name": $("#name").val(),
            "form_message": $("#message").val()
          }

          var service_id = "default_service";
          var template_id = "contact_form_ivanviladrich";
          // @ts-ignore
          emailjs.send(service_id, template_id, template_params)
            .then(function(response) {
              if (response.text === "OK") {
                $("#sendmessage").addClass("show");
                $("#errormessage").removeClass("show");
                $('.contactForm').find("input, textarea").val("");
              }
            }, function(err) {
              $("#sendmessage").removeClass("show");
              $("#errormessage").addClass("show");
            });
        }

        // var str = $(this).serialize();
        // var action = $(this).attr('action');
        // if (!action) {
        //   action = 'contactform/contactform.php';
        // }
        // $.ajax({
        //   type: "POST",
        //   url: action,
        //   data: str,
        //   success: function(msg) {
        //     // alert(msg);
        //     if (msg == 'OK') {
        //       $("#sendmessage").addClass("show");
        //       $("#errormessage").removeClass("show");
        //       $('.contactForm').find("input, textarea").val("");
        //     } else {
        //       $("#sendmessage").removeClass("show");
        //       $("#errormessage").addClass("show");
        //       $('#errormessage').html(msg);
        //     }
        //
        //   }
        // });

        return false;
      });

    });

  }

  ngAfterViewInit() {

    this.contactForm();
    //jQuery
    (function($, this_angular) {
      "use strict";
      var nav = $('nav');
      var navHeight = nav.outerHeight();

      $('.navbar-toggler').on('click', function() {
        if (!$('#mainNav').hasClass('navbar-reduce')) {
          $('#mainNav').addClass('navbar-reduce');
        }
      })


      /*--/ Start Scrolling nav /--*/
      $('a.js-scroll[href*="#"]:not([href="#"])').on("click", function() {
        // @ts-ignore
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
          // @ts-ignore
          var target = $(this.hash);
          // @ts-ignore
          target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
          if (target.length) {
            $('html, body').animate({
              scrollTop: (target.offset().top - navHeight + 15)
            }, 1000, "easeInOutExpo");
            return false;
          }
        }
      });

      // Closes responsive menu when a scroll trigger link is clicked
      $('.js-scroll').on("click", function() {
        // @ts-ignore
        $('.navbar-collapse').collapse('hide');
      });

      // Activate scrollspy to add active class to navbar items on scroll
      // @ts-ignore
      $('body').scrollspy({
        target: '#mainNav',
        offset: navHeight
      });
      /*--/ End Scrolling nav /--*/

      /*--/ Navbar Menu Reduce /--*/
      $(window).trigger('scroll');
      $(window).on('scroll', function() {
        var pixels = 50;
        var top = 1200;
        if ($(window).scrollTop() > pixels) {
          $('.navbar-expand-md').addClass('navbar-reduce');
          $('.navbar-expand-md').removeClass('navbar-trans');
        } else {
          $('.navbar-expand-md').addClass('navbar-trans');
          $('.navbar-expand-md').removeClass('navbar-reduce');
        }
        if ($(window).scrollTop() > top) {
          $('.scrolltop-mf').fadeIn(1000, "easeInOutExpo");
        } else {
          $('.scrolltop-mf').fadeOut(1000, "easeInOutExpo");
        }
      });

      // Preloader
      //  alert("on load from blog component");

      if ($('#preloader').length) {
        //  alert("preloader .length from blog component");

        $('#preloader').delay(100).fadeOut('slow', function() {
          $(this).remove();
          //  alert("preloader removed from blog component");
        });
      }

      // Back to top button
      $(window).scroll(function() {
        if ($(this).scrollTop() > 100) {
          $('.back-to-top').fadeIn('slow');
        } else {
          $('.back-to-top').fadeOut('slow');
        }
      });
      $('.back-to-top').click(function() {
        $('html, body').animate({ scrollTop: 0 }, 1500, 'easeInOutExpo');
        return false;
      });

      /*--/ Start ScrollTop /--*/
      $('.scrolltop-mf').on("click", function() {
        $('html, body').animate({
          scrollTop: 0
        }, 1000);
      });

      setTimeout(function() {
        /*--/ Testimonials owl /--*/
        // @ts-ignore
        $('#testimonial-mf').owlCarousel({
          margin: 20,
          autoplay: true,
          loop: true,
          autoplayTimeout: 5000,
          autoplayHoverPause: true,
          responsive: {
            0: {
              items: 1,
            }
          }
        });
      }, 100);

      setTimeout(function() {
        /*--/ Start Counter /--*/
        // @ts-ignore
        $('.counter').counterUp({
          delay: 15,
          time: 2000
        });
      }, 100);

    })(jQuery, this);
  }

}
